<template>
  <form class="main-body">
    <h2 class="subheading">{{ heading }}</h2>

    <v-stepper v-model="stepperCount">
      <v-stepper-header class="stepper-header">
        <v-stepper-step color="accent" :complete="stepperCount > 1" step="1"
          >Name</v-stepper-step
        >

        <v-divider></v-divider>

        <v-stepper-step color="accent" :complete="stepperCount > 2" step="2"
          >Area</v-stepper-step
        >

        <v-divider></v-divider>

        <v-stepper-step color="accent" :complete="stepperCount > 3" step="3"
          >Categories</v-stepper-step
        >

        <v-divider></v-divider>

        <v-stepper-step color="accent" step="4">Summary</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <div class="stepper-wrapper">
            <v-card class="mb-5" flat color="white lighten-1" height="200px">
              <label class="label">Name</label>
              <p>
                Give a name to the type of map you're creating e.g Supporters
                Clubs Map.
              </p>

              <v-text-field
                class="stepper__list-item-input"
                v-model="updatedData.mapTitle"
                solo
                flat
                placeholder="Enter Map Name"
                height="20"
              ></v-text-field>
            </v-card>
          </div>
          <div class="buttons-wrapper">
            <v-btn class="button-cancel" color="lightgrey" @click="cancelMap()">
              Cancel
            </v-btn>

            <div class="buttons-continue">
              <!-- <v-btn class="button-skip" flat @click="stepperCount = 2">
                Skip
              </v-btn> -->

              <v-btn color="accent" @click="stepperCount = 2"> Next </v-btn>
            </div>
          </div>
        </v-stepper-content>

        <v-stepper-content step="2">
          <div class="stepper-wrapper">
            <v-card
              class="ml-5 mr-5 stepper-2"
              flat
              color="white lighten-1"
              :height="stepperHeight"
            >
              <label class="label">Area</label>
              <p>Select the location the user see's when opening the map.</p>

              <div class="checkbox-wrapper">
                <div class="checkbox-auto">
                  <img
                    class="checkbox-image"
                    src="../../assets/map-directory/auto-locate.svg"
                    alt=""
                  />
                  <v-checkbox v-model="mapToggleAuto">
                    <template v-slot:label>
                      <p class="checkbox-label">Auto</p>
                    </template>
                  </v-checkbox>

                  <div class="checkbox-label-wrapper">
                    <p class="checkbox-label--mini">
                      The map will auto-locate to the users position.
                    </p>
                  </div>
                </div>

                <div class="checkbox-auto">
                  <img
                    class="checkbox-image"
                    src="../../assets/map-directory/fixed-area.svg"
                    alt=""
                  />
                  <v-checkbox v-model="mapToggleFixed">
                    <template v-slot:label>
                      <p class="checkbox-label">Fixed</p>
                    </template>
                  </v-checkbox>

                  <div class="checkbox-label-wrapper">
                    <p class="checkbox-label--mini">
                      Set the location of the map
                    </p>
                  </div>
                </div>
              </div>

              <div v-if="showStepperAddress" class="fixed-address-container">
                <div class="fixed-address-lattitude">
                  <label class="fixed-address__label" for="">Lattitude</label>
                  <v-text-field
                    class="stepper__list-item-input"
                    v-model="updatedData.areaLat"
                    solo
                    flat
                    placeholder="53.441111"
                    height="20"
                  ></v-text-field>
                </div>
                <div class="fixed-address-longtitude">
                  <label class="fixed-address__label" for="">Longitude</label>
                  <v-text-field
                    class="stepper__list-item-input"
                    v-model="updatedData.areaLong"
                    solo
                    flat
                    placeholder="-2.23678"
                    height="20"
                  ></v-text-field>
                </div>
              </div>
            </v-card>
          </div>
          <div class="buttons-wrapper">
            <v-btn
              class="button-cancel"
              color="lightgrey"
              @click="stepperCount = 1"
            >
              Back
            </v-btn>

            <div class="buttons-continue">
              <!-- <v-btn class="button-skip" flat @click="stepperCount = 3">
                Skip
              </v-btn> -->

              <v-btn color="accent" @click="stepperCount = 3"> Next </v-btn>
            </div>
          </div>
        </v-stepper-content>

        <v-stepper-content step="3">
          <div class="stepper-wrapper">
            <v-card flat color="white lighten-1" height="400px">
              <label class="label">Categories</label>
              <p>Select a category to populate your map with i.e Stadiums</p>

              <v-layout>
                <v-flex>
                  <v-label v-if="!selectedCategory">
                    Select a category
                  </v-label>
                  <v-select
                    v-model="updatedData.categoriesArray"
                    :items="unselectedCategories"
                    item-text="attributes.title"
                    @change="($evt) => (selectedCategory = $evt)"
                  >
                  </v-select>
                  <v-btn
                    v-if="
                      categoriesArray &&
                      selectedCategory &&
                      categoriesArray.filter(
                        (c) => c.attributes.title == selectedCategory
                      ).length
                    "
                    class="accent"
                    type="button"
                    @click="
                      updateSelectedCategoriesArray(
                        categoriesArray.filter(
                          (c) => c.attributes.title == selectedCategory
                        )[0]
                      )
                    "
                    >Add</v-btn
                  >
                </v-flex>
              </v-layout>

              <!-- Need to see if i can use the same array and only display the title or ID which i need. -->

              <div class="selected-categories-container">
                <div
                  v-for="category in selectedCategoriesArrayTitles"
                  :key="category.id"
                >
                  <div class="selected-category-wrapper">
                    <p
                      v-if="selectedCategoriesArrayTitles.length"
                      class="selected-category"
                    >
                      {{ category.title }}
                    </p>
                    <v-icon
                      class="selected-category--icon"
                      @click="deleteSelectedCategoryTitles(category.id)"
                      >delete</v-icon
                    >
                  </div>
                </div>

                <div
                  v-for="category in selectedCategoriesArray"
                  :key="category.index"
                >
                  <p class="selected-category">{{ category }}</p>
                </div>
              </div>
            </v-card>
          </div>
          <div class="buttons-wrapper">
            <v-btn
              class="button-cancel"
              color="lightgrey"
              @click="stepperCount = 2"
            >
              Back
            </v-btn>

            <div class="buttons-continue">
              <!-- <v-btn class="button-skip" flat @click="stepperCount = 4">
                Skip
              </v-btn> -->

              <v-btn color="accent" @click="stepperCount = 4"> Next </v-btn>
            </div>
          </div>
        </v-stepper-content>

        <v-stepper-content step="4">
          <div class="stepper-wrapper">
            <v-card class="mb-5" flat color="white lighten-1" height="200px">
              <label class="label label-summary">Your Map</label>

              <div class="stepper-content-container">
                <div class="stepper-content">
                  <label class="stepper-content-label">Name</label>
                  <p class="stepper-content-label--mini">
                    {{ this.updatedData.mapTitle }}
                  </p>
                </div>

                <div class="stepper-content">
                  <label class="stepper-content-label">Area</label>
                  <img
                    v-if="this.updatedData.areaType === 'auto'"
                    class="checkbox-image--mini"
                    src="../../assets/map-directory/auto-locate.svg"
                    alt=""
                  />
                  <img
                    v-if="this.updatedData.areaType === 'fixed'"
                    class="checkbox-image--mini"
                    src="../../assets/map-directory/fixed-area.svg"
                    alt=""
                  />
                  <p class="stepper-content-label--mini">
                    {{ this.updatedData.areaType }}
                  </p>
                </div>

                <div class="stepper-content">
                  <label class="stepper-content-label">Categories</label>

                  <svg
                    v-if="selectedCategoriesArrayTitles < 2"
                    class="stepper-icon"
                    width="26"
                    height="30"
                    viewBox="0 0 26 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 15.2866C13.8594 15.2866 14.5953 14.987 15.2078 14.3878C15.8203 13.7885 16.126 13.069 16.125 12.2293C16.125 11.3885 15.8187 10.6685 15.2062 10.0693C14.5937 9.47006 13.8583 9.17095 13 9.17197C12.1406 9.17197 11.4047 9.47159 10.7922 10.0708C10.1797 10.6701 9.87396 11.3896 9.875 12.2293C9.875 13.0701 10.1813 13.7901 10.7938 14.3893C11.4063 14.9885 12.1417 15.2876 13 15.2866ZM13 30C12.7917 30 12.5833 29.9618 12.375 29.8853C12.1667 29.8089 11.9844 29.707 11.8281 29.5796C8.02604 26.293 5.1875 23.2418 3.3125 20.426C1.4375 17.6102 0.5 14.9799 0.5 12.535C0.5 8.71338 1.75677 5.66879 4.27031 3.40127C6.78385 1.13376 9.69375 0 13 0C16.3073 0 19.2177 1.13376 21.7312 3.40127C24.2448 5.66879 25.501 8.71338 25.5 12.535C25.5 14.9809 24.5625 17.6117 22.6875 20.4275C20.8125 23.2433 17.974 26.294 14.1719 29.5796C14.0156 29.707 13.8333 29.8089 13.625 29.8853C13.4167 29.9618 13.2083 30 13 30Z"
                      fill="#000"
                    />
                  </svg>

                  <svg
                    v-else
                    class="stepper-icon"
                    width="70"
                    height="70"
                    viewBox="0 0 70 70"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <rect width="70" height="70" fill="url(#pattern0)" />
                    <defs>
                      <pattern
                        id="pattern0"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlink:href="#image0_212_8260"
                          transform="scale(0.0016)"
                        />
                      </pattern>
                      <image
                        id="image0_212_8260"
                        width="625"
                        height="625"
                        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAnEAAAJxCAYAAAAtjeQ4AAAACXBIWXMAAC4jAAAuIwF4pT92AAAgAElEQVR4nOzdX2zUV5r/+WdGo5WNFuKG+UkgmwlIaw+OVsL0T8IyN3EMXHREujOOkovQkquTG9NRMgyRYHfAmoqMR6Kl0I6jbqxdJamSmmgFogYai9YKXBitRK25aNs3XUz5wka2ZUs7dht716677EV9zb/Ydc636vvvnO/7JUU90xzgdADzqec55zl/88MPPwgAAADM8rdhbwAAAADuEeIAAAAMRIgDAAAwECEOAADAQIQ4AAAAAxHiAAAADESIAwAAMBAhDgAAwECEOAAAAAMR4gAAAAxEiAMAADAQIQ4AAMBAhDgAAAADEeIAAAAMRIgDAAAwECEOAADAQIQ4AAAAAxHiAAAADESIAwAAMBAhDgAAwECEOAAAAAMR4gAAAAxEiAMAADAQIQ4AAMBAhDgAAAADEeIAAAAMRIgDAAAwECEOAADAQIQ4AAAAAxHiAAAADESIAwAAMBAhDgAAwECEOAAAAAMR4gAAAAxEiAMAADAQIQ4AAMBAhDgAAAADEeIAAAAMRIgDAAAwECEOAADAQIQ4AAAAAxHiAAAADESIAwAAMBAhDgAAwECEOAAAAAMR4gAAAAxEiAMAADAQIQ4AAMBAhDgAAAADEeIAAAAMRIgDAAAwECEOAADAQIQ4AAAAAxHiAAAADESIAwAAMBAhDgAAwECEOAAAAAMR4gAAAAxEiAMAADAQIQ4AAMBAfxf2BgBApbuxp/2F/3ef889m2jf576adfzYz8uK6wcnerdYBQOT8zQ8//BD2HgDEWHdjT4uI1MnzALbxn/tE5PXgdyQiIhMisizPA+DGP+ODk73LIe0JAF5CiAMQCCestUgpnLVLuCGtWg/kebAbEcIdgBAQ4gB47oXAtvHPm+HuKBBPRGTc+WdECHYAfEaIA1A158xau5QCW7uIvBbidqJkQp6HuhHO3AHwEiEOgGtOpa3d+ecXoW7GLE9E5KY8D3VU6gBUjBAHQEt3Y8+7IvKulIKbqWfZouaBlELdTap0ANwixAHYVHdjT52UQtu7QrUtCBtVutTgZO942JsBEH2EOADPmBLcmg7v2/S/b2jeI9t21Lz0383kF2R9Zf1Ha/9rblmW5iLbzSTQAVAixAF4sVXaFeY+mg7vk9odtbK3eXfp/2/dLyIitTtqZG/zHt9+3rWVoszm50VEZHFuWRZn//rsv1tbKcrs4wXffm4NT0SkX2i5AngFIQ6Iqe7Gnn0iclpK4S2wM2476+vk7+vrpKl1v+xq+Insqq/btIIWNRvhrjA69fz/fjQd9DYeSKk6lwr6JwYQPYQ4IGa6G3sSIpKQAGa37ayvk73Ne2Rv825pat1vRFhzayY/L7P5BZn5y7zM5ueDCnZPRSQlIv1U54D4IsQBMeCcdTstpfDmW9Wt4UAprO19Y0+p0lZf59dPFWmF0SmZyc9LYXRaCqNTsr5a9POneyClMHfTz58EQPQQ4gCLOS3TpPh01m1nfZ38Y+t+aWrdLwePNVtXZfNKKdBNycTdvJ+VuidS+rW+yfw5IB4IcYCFnBcUkuJDy7ThwG5pe+9QqeLm42UDW62tFEuB7l5exu/m/ajSPZXSRYh+whxgN0IcYBG/wtvBY83ScryZapsPZvLzkrsxJuP38l6PPOHcHGA5QhxgAWdESFJEDnr1YzYd3idt7/2U4BYgHwNdWkSShDnALoQ4wGBeV9521tfJ0USbtBx/I7aXEqJi/G5eJu7lJZcZ8/KH/UpKYY42K2ABQhxgIC/DW+32Gmk53ixtnYeeDddFdKytFGXiXl6Gv3vo1dBhzswBliDEAQZxbpv2iwdPYm1U3do6f0q71BAz+XnJpnJeVeeeSqkq1+/FDwYgeIQ4wADOnLekiPxztT/WwWPNcjTRRtXNYGsrRcmmHsrDzJgXZ+eeiEhicLJ3pPqdAQgSIQ6IOOeFhX4Rea2aH6et85Cc+KyDs26WyWXG5PZA1osw90BKYW66+l0BCAIhDogo59xbv1Rx47R2e40cTbRJR+IILVPLFUanZGgg68Uw4S+E83KAEQhxQMR40TolvMWXR2HuiYic5ikvINoIcUCEOPPeUlJh65Twhg0ehblbUmqxUpUDIogQB0SAF7dOT3z6FuENP+JBmOMWKxBRhDggZN2NPael1D6tqPrGhQXo8OACBBcfgIghxAEhcc6+paTC6lvT4X3y/oW3eYQergwNZGU4lZP11WIl352qHBAhhDggBNWcfdtZXycfnH9bWo43e74vxMPaSlGu992pZmgwZ+WACCDEAQFyqm/9ItJVyffn3Bu8NJOfl/TZTKXPeT0VkXcZEgyEhxAHBKS7sadFRG6KyOtuv2/T4X3S9Zv3OPcGXwynHsrQwP1KW6xfDU72nvZ6TwDUCHFAAJzLC791+/1qt9fIBxfelrbOQz7sCnhubaUo6XMZmbiXr+S7T0ipKjft7a4AlEOIA3xUzeWFg8eapetSJ61TBGr8bl7S5zKVVOWeSumcHAOCgYAQ4gCfVNo+rd1eI12XOrm4gNBUWZWjvQoEhBAH+KDSR+upviFKqqjKPZBSe5Xbq4CPCHGAx7obe/rF5bunnH1DVFVRlXsqIu2Dk73jPmwLgBDiAM84599uisibbr5fw4HdcmrwJDdPEWkV3mB9KiKnByd7U/7sCog3QhzgAef8W0pEDrr5fic+fUtOfNbhy54Ar1UxV45zcoAPCHFAlZwANyIuzr/Vbq+RU1c+lKbW/b7tC/BDFa89pKVUleOcHOARQhxQBecCw3duvk/T4X3SfeUklxdgtFxmTK5dvOO2vTohpXNyBDnAA4Q4oEKVDPDt6GqTDy687dOOgGDN5OflyqnvZWnOVSabkNI8OS48AFUixAEV6G7sSYmL90+5fQpbVXh7lZurgAcIcYBLbgPczvo6OXXlQ9nbvMe/TQEhu3bxjmTTOTff5amUZsmN+LMjwH6EOECTM0JkRFzcQG04sFvOXP2Y82+IhVxmTNLnMm6/268YQQJUhhAHaKgkwLV1HpKuS52+7QmIopn8vFw++a3bCw8EOaAChDhAoZIAx/w3xNni3LJc6b7qdp4cQQ5wiRAHlFFJgOu61MkFBsTe2kpRLp/8hiAH+IgQB2zBbYBjgC/wY+lzGbeDgQlygCZCHLCJSgLcmasfcQMV2ARBDvAHIQ54BQEO8F4FI0gIcoACIQ54gdsAxwgRQF8FI0gIckAZfxv2BoCoIMAB/qpg7M53zvvEADZBiAOeGxECHOArghzgHUIcIM+e0iLAAQGoIMj1dzf2tPi1H8BUhDjEnpu3UAlwgDdcBrnXRGSEIAe8jBCHWOtu7DktBDggFBUGuX3+7QgwCyEOseWcs/mtzloCHOCPCoLcTecSEhB7hDjEUndjT7uIfKeztjQHjgAH+MVlkDsoIjd93A5gDEIcYsc5V6P1l8DGIF8CHOCvts5Dbt4cftM5ywrEGiEOseK0YVJSasuUxUsMQLC6LnW6CXJdzplWILYIcYibm6I5SuTUlQ8JcEDAui51ysFjzbrLf9vd2POun/sBooxnt2LAaR9uHARu1/xuyyIy7vzf04OTvdMebytwbkaJuKwIAPDQ2kpRLp/8RmYfL+gsfyoi7YOTvePKlYBlCHGWcK7dt7zwT52IvOnxT/NUSsFu2vlnRETGByd7lz3+eTzn3ETVushw4tO35MRnHf5uCEBZaytFufjz38nSnNaXlwkpBbnIfy0CvESIM5Rzu3LjnxbROOPloydSCncjIjIStU/ETiVyTGdtBZPkAfhkJj8vl09+K+urRZ3ltwYne2mtIlYIcYZwKm3vSim0/SLUzag9ldLZsxERuRnmp2PnIsO4iLyuWttwYLdcuP2J/5sCoK0wOiWXf/mt7vIvBid7kz5uB4gUQlyEvRDcEqJ5GD+ibkkp1AUe6Lobe0ZEo628s75OLvzxE0aJABGUy4xJ+lxGd/lbg5O9Iz5uB4gMQlzEOJWjhJgf3LZyS0RSg5O9vg/r7G7sSYrIv6nWMUoEiL70uYzkMlqnIp6KSIsNl7EAFUJcRDjntrTf8bTAEynNa0v58cXWOTN4X2vt7z+UluPaIw0AhOTyyW+k8GhaZ+nE4GRvi8/bAUJHiAuZc2syId7fJDVJWkT6vboQ4VQzp0Xjsgc3UQFzuLyx+tXgZC/DgGE1QlxInPCWFI0D917aWV8nf1+vfjt6Jr+geyPMSw9EJFnteRbdc3AHjzXLqSsfVvNTAQjYTH5e+n7+e93lnI+D1QhxAfM7vNVur5G9zbuloXmP7Gqok73Ne6R2R01V570Ko1PP/nNxblkWZ/+q29KoVMVhznmG57eqdVxkAMzl4qLDUxHZx/w42IoQFxDnjFZSPG6bNhzYLU2t+6Wpdb/sfWOP7NKosnllJj8vs/kFKYxOyX+OTum2ONxISynMTessdjMP7vwff81FBsBgLi46MD8O1iLE+cwZE9IvHs12q91eIy3Hm+XgsWZpat0fqUrS4tyyFEanZPxuXibu5b36YZ9K6d9ff7lP0845uBHRuNH7/vmfydHEEa/2ByAELp/m+pfByd5+v/cEBI0Q5yNnxMVpqfI1hReDmym3KNdWijJxL+9loHsiIomtWqzdjT39IvLPqh+Ec3CAPVy86MDYEViJEOcDp62XkirnvB081ixtnYeMCW5bWVspSi7zZxlO5bxoud6SUph79gPpjhPhHBxgn+HUQ7ne9yedpQ8GJ3vbfd4OEChCnMd0B8xupXZ7jbR1HpKjvzoS6Pm2oBRGpySXGdM9y7KVp1IKcjfdPKt15g8fSVPr/mp+XgARdOXU97oVf9qqsAohziPVVt9qt9fI0USbdCSOxKJStDi3LEMD2WrDXFpE1kWkW7WQeXCAvdZWinK+/UvaqogdQpwHnLEh/VLB2bfa7TVy4rO3YnvQ3qMwVxYP2wP2K4xOyeVffquzlLYqrEGIq4LTyuuXCp7KilvlTcWvMMe7qEB8XLt4R7LpnM5S2qqwAiGuQs7okJtSQfu0rfOQvH/+bcLbJgqjUzI0kPVsmDDjRID4cPEsF21VWOFvw96AiZzzb+PiMsA1HNgtZ/7wkXRd6iTAbaGpdb+cufqxvH/+Z1K7vbp/R02H9xHggBjZtqNGEpc6dZa+JqUuCmA0KnEuOeffvnP7/ThY797aSlHS5zIVzZmr3V4jF25/YuUNXwDluWir/tPgZO9Nv/cD+IUQ50IlAa7hwG7p+k0nZ7KqMH43L+lzGZ2bZ88QmoH4ctFWfSKltipvq8JItFM1dTf2pMRlgOvoapMLtz8hwFWp5XizXLj9ifxP//0ftNY3HNhNgANizEVb9XUpvaoDGIkQp8EJcNo3UGu310j37z+UDy687d+mYmZXfZ38w/9cr7W26zdaX7wBWKypdb8cPKb12s2/ORfVAOMQ4hTcBriNmWSmP5UVNTP5ea0zLh1dbVQ+AYiISNelTt0LUimftwL4ghBXhtsA19Z5SM5c/ZjD9D64fvGOcs3O+jraqACe2bajNExdw5vOG8yAUf4u7A1EldsAx0F6/4zfzWvNjfuA2XuxtzS3LP+1xWH2vc27qx5bA/McTRyR3I0xmX28oFqaEpF9vm8I8BC3UzfhNsB1XeqUts5D/m0o5v61/UvlLbOmw/vkzNWPA9oRwrK+WpSZ/IIURqdkcfavsji3/Ow/3djbvEdqd9RIU+t+2bajRhqa90jT4X3+bBqhc/EkFy85wCiEuFd0N/acFpHf6qyt3V4jp658KE2t+33eVXwNpx7K9b4/Kdf1jXxOG9tCS3PL8p+jU1Jw/nEb1tza27xHmlr3S1PrPmlq3U/lziLpcxmdZ/2eisg+Ro7AFLRTX+DMgdMOcLzJ6a+1laIMDdxXruvoaiPAWWT28YLkbozJ+N2/+B7aXjWTn5eZ/LwMpx6KSCnUtb13SFqONctOfo8Z7f3zb8v43bxq3uRrUho5kgxkU0CVqMQ5nKe0tF5fJ8AFY2ggK0Nflw9xtdtrpG/kc87CGW5pblmGU7lQgpuuvc17pCPRJi3Hm6nQGUrna4rwrioMQoiTZ4/Zj0vpU1hZBLhgLM4ty8V3fqd8pYEH7s02cS8vw6mcFEanwt6Ktm07auTgsWZ557MOqnMG0jljKyLpwcnehP+7AaoT+xDX3dhTJyIjovGYPQEuODrnV3bW18m/j3we0I7gpVxmTIYGspGtuulqat0vJz7r4FKEQXKZMUmfy+gs3U81DlHHnDiRftEIcCJCgAvI4tyyzgFk+eA8L2KYJpcZk/PtX0r6XMb4ACfi3Ho8+Y1c/uW3WmNwEL62zkO6oTvp706A6sW6EufmJipjRIKjU4VjpIhZCo+m5frFOzKTnw97K75q6zxEm9UALkaOhFqNc4767FOtG5zsHfF7L4im2IY4NxcZOHcVnMW5ZTnf/qVy3Zk/fMRoFwOsrxbl2sU7WpVVW2zbUSMdiSNy4lOtlwIQkssnv9Gpnvp6Ns55JWKf80+LiNQ5//frVfywEyKyLKVz3stSOi40TWvYTrEMcc45uHHR+IPS1nlIui7xoHpQqMLZY+JeXtLnMrK2Uv5yiq32Nu+Rrt90SsOB3WFvBZsIuhrnBLYWEdn4z2qCWqUeSOnvvnERGSHYmS+uc+L6ReMPUMOB3QS4AOmeheN5s2hbXy1K+lxGxu/mw95KqGby83Lxnd/Jic86qMpFUFPrfmnrPKTzNScpIgm3P77T7WkXkXdF5E23398nb8oLe+lu7HkipUrdTSmFOvMPqsZM7Cpx3Y0974rIf6jWMX8seFThzDf7eEGudF+14tKCl5pa98upKx8yXy5idI9viGY1zgluCSkFtzAqbdW6JU6oo0pnhliFOKeNOi0a8+DO//HX3EQNEGfhzOdidEMsbdtRI2eufkx7NWI0n+Pa8mycBcFtK7ekVKG7SYUuuuIW4m6KyC9U67jIEDydSepU4aJL8y9CCDfdo6aSapxTEHhXSk90aY2oMthTKYW5/sHJ3vGwN4OXxSbEOYdKle+tEBSCt7ZSlPPtXypfZ6AKFz3rq0W5cup7o15ciALOyUWL5oeQL0QkJaWq22nR6OhY6IGIpAYne1NhbwQlsRj263xqSqnW1W6vke4rJ/3fEF6Sy/xZGeCaDu8jwEXM+mpRLp/8lgBXgaGBLK3nCNGsjP6vIjIlIv8m8QxwIqVLEd91N/ZMdzf2JMLeDOJzO/W0aJxV6LrUyUWGEAyncso13EiNlo0AZ/vwXj9tVH64AR++ptb90nR4n2pu3P/g18/fcGC3bNtR8+yD6sZ/1u6oUZ7NXlspyqzz53BxblkWZ//67D9n8gvKD8gVel1KYS4pIkkqc+Gxvp3qTLxWlgoOHmuWU1c+9H9DeInOYXha3NFCgPMWsyijwcXcuKo0HNgtTa37Ze8be6ShebfvF+g2Ql5hdEpm8gtSGJ3yI9g9EZHTg5O9N73+gVFeHCpx/aoFtdtr+CIaktyNPyvXtL330wB2Ah0EOO9RkYuGptb90nBgt8w+XvD0x91ZXyctx5pL1b7W/YF3ezYqfC8eR5lxQl1hdFom7nkyz/F1EfmP7saeB1IKc1yACIjVlTjdywzcFgvHTH5e+n7++7JrdtbXyb+PfB7QjqDS9/PfE+B8wmWHcBVGp+R/+/T/kP/3r2tV/1gbwa3tvUORH1W1tlKUwuiUTNzLe3nD/CsptVkZTeIz20PciCgmZdOqC4/OjTDGvUQHY0T8xwfK4K2tFOV6X/Xv+9Zur5G2zkNGBLetrK0US2Huxp913pVVocUaAGtDnG4VLs5Dfbf6Q9p0eJ/vP/faSlHO/Pe+smt4NSM6hr6+L0MD2bC3EQsXbn/CQOCAjN8tve9bzRmxhgO75eivjlgXvhfnlmX4u4eSy4xVe4bulogkqMr5w+YQNy2KG6lxOlBceDTtnIGYktn8vPJR8o1zFA3Ne6TleLPnf6kMpx7K9b4/lV3T0dUmH1x429OfF+4VHk3L5ZPfhL2N2Ni2o/ThhSe6/LO2UpShgaxk0+qb8Vs5eKxZjibarB99tLZSlGzqoTzMjMlS5c/pPRWRdwcne0e82xlELA1xzvya78qtiUOVZ/bxggx/91Am7uWVoU1lV32dtBx/Q44m2mRnfV3Ve/vX9i+VXxD6Rj6XXR78XKjc+mppEHO1v3/gTlPrfjnzh4/C3oaVZvLzkj6bqfgCQ1vnITnxWUcsvzblMmNyeyBbTZj7anCy97SXe4o7W0PcuCieQjnx6VvWzh4rPJqWoYGsb0NYW443S0fiSMVtV52r/JxVjIbLv2SYb1i46OC9at73bTq8T96/8HZsj9+8aGggK8OpXKVt1gkpVeWmvd1VPFkX4nTOwtlahZt9vCDXLt4J7C/dts5D8sGFt123fXQOyHf//kNpOd5czfZQpWw6J9cu3gl7G7HG+TjvVHoxZ2d9nSQudVrfNnWrypY07VWP2PjsVlK14GiizboAN/T1fbn4zu8CrZrkMmNyvv1LV18Y11aKyvU76+sIcCFbmlvmIkMEpM/yNFe11laKcvGd37kOcLXba+TEp2/Jv498ToDbxLYdNfLBhbelb+TzSroyr4nIfZ7uqp5VIa67sadFFCNFarfXSIdFIyvWV4vS9/Pfh/YX7tpKUdLnMto3vHQGSx6x7JaXiVLnMpyDi4CZ/LwMfa28ZI8tzOTn5Xz7l67PvzUd3icXbn9i7ZEbL+2qr5MzVz+WrkudlVzG+a67sSflw7Ziw6oQJ6U3UsuyqQo3+3hBzrd/GYnhq7nMmFw++a0yyA1/91D5Y/FCQ7hymTHOwUVINvWwmoPksVUYndL6mvSi2u018v75n8mZqx/H8uJCNdo6D0nfyOdy8JjrLkpXd2PPze7GHv6FV8CaEOf8Bugqt8amKtzs4wW5fPKbSFVLZvLzZb9oLs4tKz8RHzzWzBfPEK2vFmmjRszaSlFu82viSi4zJpd/6S7AbVTfGC5euW07auTUlQ/l/fM/c1uV+4WIjBDk3LMmxIlIQrXAlipcFAPchnJBTqcKx1m4cA2ncrJI1SdycpkxLybox0IlN1BPfPoW1TcPHU0ckTNXP3J7KeegEORcsynEKVupNrTpluaWIxvgNmwV5MYV5+E2nq1BONZXS0M9EU1USNXcBrja7TVy5g8fcfbNB3ub98iZqx+7/ZpOkHPJihDnjBVRvs5gw6esK6e+j3SA2zCTn39pPMVMfl55rocqXLiGUzkjfm/FVWF0impcGW4DXMOB3XLh9ifcPPXRth010nWpU94//zM3340g54IVIU40Wqk2VHiu9/0pEpcYdOUyY8+u9eduqK/32/BrZCqqcGagGrc5twHu4LFm2qcBOpo4Imf+8JGbc3IEOU3GhzjnF/ndcmt21tcZ/2mr8Ghahg38S/Z63x1ZmltWtlJt+DUyGVU4MxRGp7ip+gq3Aa6t85CcuvKhFeejTdLUul/OXP3IzbONBDkNxoc4KQW418otOJpoC2gr/kmfvRH2FiqytlKU9P+SUbdS3V9Lh4dyN/4c9hagiZuqz7kNcF2XOqXrUqePO0I5e5v3yIU/unqFhCCnYEuIK6vl+BtB7MM3ucyY0TcG//P/Vs8ca3uPVmpYJu7ljf79FTcT9/KVvllplVfP3ap0XerkyEYEbNtRI2eufuw2yKX825HZjA5xTjr/Rbk1Nswds/0czM76Oh6VDlEl70kiPGsrRRm/q375xGaqmZSvIsBFSwVB7he87LA5o0OcaFXhzG7TmV6F00ErNTzrqwQCE2VTFT06boW1laKkz+o98ydCgIuqCoJcF2+t/pjpIa5dtaCCJ0AiJQ5VElqp4YnD7y8b6YzssdXgqavab6ES4KKtgiD3nTNSDA7TQ1zZStzBY81G30Bamlu2/g1LWqnhogpnLtWNbxtdu3hHe1YeAc4MFQS5m92NPft83JJRjA1x3Y09LaK4lWp6KzUOX6RppYZnfbVo/YcEm+nMXrTJ+N28ZNN6beQTn75FgDPIRpDTHD/ymojc9HlLxjA2xInGeTjT547F4S9Y03+NTEYVzmwz+fnY3FJdnFvWHiXS1nmIZ7QMtG1HjZy68qHuQOCD3Y09/X7vyQQmh7j2ct/YcGC38bdSbQ9xtdtrjK+Wmsz2319xEJdfwyvdV7UCa9PhfcyBM9je5j1y6sqHusv/ubuxR1nMsZ3JIe7Nct9oeoVnaW7Z+gn6pv8amS4uAcBmhdHpsLfgu6GBrNZFhoYDu6X7yskAdgQ/NbXudxPEU3E/H2dkiNO5nWJ6hee/YnDzzPRfI5MtzS1bP7omDmwP4oXRKRn6+r5yXe32Gun6TafRF9nwXFvnId0zja9JzAcBGxniRGO0iOlVnlmDHrqvlOm/RiabicHvrziw+ddxbaUoKc1zcF2XOrnlbpmuS526N1bf7G7sOe33fqLKyhDXdHhfMLvwke2tVBvOLJpsJq83ZwvRpztywzRDA1mtWXgdXW1U9S11avCk7kWHZFzbqqaGuJZy30iFJ/r4NQqX7W24OLGxaj+Tn9caJ9JwYLd8cOHtAHaEMOyqr9M9HxfbtqpxIc5J22XnwzVQVo88Qly41i2v9MaJjVX79Fl1G3XjHBzs1nK8WTq62nSWvhnH26rGhThRVOFECAgmoP0RLpvPUsWNbVXV4dRDrduoJz57i3NwMXHisw7dQcCp7saeWJ3TsS7E7ayv44ZSxNlwZtFkcX1zE9G3tlKUoQH1bdSmw/vkaOJIADtCFGzbUSMJ/bZq0t/dRIuJIa693Dfa8snM5mqizf/bTBCH8TVxYlMl7nrfHeVQ31Ib9b2AdoSoaGrdr9tW/ec4XXIwMcTtK/eNe5u1H9GNNJuriYQ4AK+ayc9LLqN+D/Zooo2b7THlpq3q81Yiw8QQ93q5b7TlUoPmfBwj2fJrZCobbzPGnQ1vqF6/eEe5puHAbt5FjbFtO2rkg/Nat5Hf1HkUwAZGhZ9PUPEAACAASURBVLjuxh7lpYZdDfZ8QrOxYtVwYLfVVUYT2HibMe5Mn/tXGJ3SmnfHOBG0HG/WPVed9Hcn0fB3YW/AJWVCs+VMnEgpxNl03kXEzmAKoDpDA1nlmoPHmmP19aPwaFoKo1Mym5+XtZXipn8X7Kqvk10NP5G9zXukoXm37H1jj9VdnA1dv3lPzrd/qVr2ZndjT/vgZO9IAFsKjWkhrr3cN2r2yo3RcrxZ64ubSfa+YU/IBlA9qnDP5TJjMnEvL+N381rrF503kF8MeLvq66Tl+BvS9t4hawPdrvo66ehq0xkInRSNZzpNZlqIK+vvLQtxG09T2fRQeZw+SQNQ0/mgeuLTt6y9zLC+WpThVE6yqYeeHHVYnFuW4dRDGU49lL3Ne6Qj0ab7mLxRTnzWIbnMmOo8qPXVOKPOxIkiUdfuqA1oG8E5+it7ZiHVbq+x9gsxAPd0qnC122ukw8KZcOurRRn6+r6cb/9ShgayvpxVncnPS/pcRs63f2ndG7vbdtTI0YTWyJGkz1sJlWkhrixbxou8qK3zkDUXAWz89QFQOZ0q3NFEmzVfAzcUHk3LxXd+51t4e9Xi3LJcPvmNDP76eytuMm/oSByR2u3K3xtW31Q1LcTFroxj06dQWqmAP0w8SrI4txzLKtz1vj/J5ZPfhHJMZvxuXs63fykT9/TO3EWdi2rcab/3EhbTQtzBct9o6/wxWz6J2vrrYxrCtH1MvNQVtyrc+mpR+n7+exlOPQx1H2srRbly6nudSwFG0KzG/cLWVxxMC3Fl2fKH/VW122usGHDJzVQAIqUgoXqdwaYq3PpqUS6f/FZmIjRo+9rFO5I+lwl7G1WLezXOqhBns46uNqMrKFxqiA5bP+zElYl/rnKZPyvX2HIeOIoBbkMuM2ZFkNMM+4nuxh7z/rAoGBPidEqhtRb8gS8ncanT2C9qXGqIDltnR8XVroafhL0F14ZT6laeDTfzoxzgNuQyYzL09f2wt1GVbTtqdMaovCYi7wawnUAZE+JE8fC9iF2vNWxmZ32ddF3qDHsbFeE8XLSY+mEAP2ZaJa4wOiVLikP9B481G/e/azPpc5lIB7gNQwNZZXs76jSPHCV83kbgTApxkNIXNxODnE1v2tqAUG0P0ypxOmFB84xTpA19fV/75YUouN53Rxmuo2xXfZ3Om6pv2nbBgRBnoLbOQ8YFOdurpKbh18MeJp2VXVspKoPNzvo6o/43bWb28YJxTyaurRQlZfj5uLb3fqqzzKoLDoQ4Q5kW5Kj8REsDZxStYdJ504l7eeWwWRuqcNcu3gl7CxUpjE4Z3VZt6zykM27EqnNxhDiDtXUeklNXPjTifJMJe4wTxr3YYVd9nc5fWpGh015sOf5GADvxTy4z9tKD9Ka53nfH6FcdNC44vN7d2NMSxF6CQIgz3MFjzXLhj5+E2h77b/+ws+y3a5xTQMAaDuwmWFvApLbj2kpR+VKADRcaTGujvmptpah1eziq2t5ThjgRiy44EOIssLO+Ts7/8dfywYW3A/2LeVd9nZy68qH8ZPeO8usMO3gdFyYFAGzOpF9DnaeeWo43B7AT/+QyY6E8p+W1bMivSlRjb/MenRdMrGmpEuIs0tHVJn0jn+uUk6uybUfpBYkLtz+Rg8ealQ84m/7J2lYmBQBs7h8N+jXUaTEePGZ+iLOBzosaUdai/n1kTUvVqhCnChNxULu9Rroudcpv/3xeTnzW4WmA2tu8R7oudUrfyOdy4tO3np3FmX28UPb7UYmLJo0vdIiwXfV1Rr2ZqjoPd/BYs9Et/qW5ZaPPwr1Kp3IaVZot1XaftxGIvwt7A7oGJ3tHuht7yq6Zzc9TXXDUbq+RE5++JSc+fUtmHy9I7kbpsK3bwZNNrfulqXW/tBxv3nTSv05wphIXTTvr62RXfZ0V7Z84MukCQGF0SnlY3vRW6rjBoWcz43dLN4lNujizYaOlqph7966I9Ae0Jd8YE+JQuYYDu+X98z979v8XHk3L4uxft/zLe2/zbtnV8BOt55lmNUIhlbjoajn+hgwbfP4lzjSrDZGgcyvV9FaqTVW4DeN3874fz/FLy7FmyabLXtB4s7uxp25wstfoT7FWhTgqCnqaDu8TCfDGKJW46Gp77xAhzkC76uuMegNXFXBsuC1t0usMumbz5Y/KRFnLcWWIEym1VG/6vxv/mHYm7kG5b1yc/WtQ+4BD9cXZpDM7cdRwYDevNxjIpFbq2kpReW7W9Faq6n+fqUx493Urmker2n3ehu9MC3FlUYmLnr8nxEVehwUT8uPGpFcNdNqMpp9ltrWAYHqLWKNF3x7ANnxlWogbL/eNtv5BirIZg8vtKGk5bvatwLhpat1vVIVb59ys6SHO5q+DJr/e0NS6T7XkYHdjjzl/mDZhWogrW2qz+Q9SVK2vrJf9dtO/OMdB7fYa4w+Vx4lJVTgRdTWHF12izeS/VzX//jF6XpxpIW6k3DeurxaZFQdU4J3POsLeAjTsqq8zLnAXHk2X/XYbPujRBYomzfO+7T5vw1emhbhp1QKd0j28o/oCzXgRM+ysrzN2lECcnDAsbOscjLcixHEeO7I0Kr3t/u/CP0aFuMHJ3mkReVpujekHMW3DeBFzUI2Ltl0GBm2dERU2hDhueEeXxu8v2qkBK3u5weT+PRAmqnHRZloVTkRk5i/lK3Emzborp5aLQZHVoA7Yr5l8ucG6EEclLjg6rRK+uJmFalw07W3eY2TAVh1v2fsGFayoM/3iiebvMWOrcdaFuPXVIucTArKucYmENoNZdtbXGVnxsd37F94OewsVUXVGbDluYUNL2Fa76ut03n9tD2ArvjAxxI2oFlCNAyp3NNFmzV+uNmjrPGRkNWRtpaicMWZL+LF1qLktvz57m5Vte2N/AY0LcVxuAPxVu71GPjC08mObbTvM/bXQmRRgy+31nfV1Vg7MtqWTonEujnZqwEbKfeN/EuICQdvaXgePNRv/nqUNui516rSCIknn64NNFV9bqlYv0njxwAgaAXtfANvwhZUhbmlumYARANWASxNbQHiu61KnVX/JmqbleLNxg31fpPr6YMvN1A0m/1ptxZZgqvG/4/Ug9uEHK0OcCC1VoFq122uk6zfvhb2NWNpVXyddlzrD3kZVVB+kbWs/2la5bjnebGwVuBLdjT1GtlSNDHGDk73jojgXN343H9BuAHs1Hd7HbdUQnBo8afxfoMpKvSVVng2122usCnImjrTZiubvNSPbDkaGOMdIuW+kEgd448Snb1n1l1PUdV3qtK7VGBcdiSNhb8ETJr7R6wFCXMBulvvG9dUi1TjAI12XOq25qRZlbZ2HrKmAqN5V1rgxaJymw/usqDDaWH3X+GBEOzVgI6oFVOMAb9Rur5FTVz607hxTlDS17jf+HJwbtv5eMj0AmfhGrw5bf78ZG+KceXET5daM36MSB3hlZ32dnLn6sbVfDMO0t3mPnLryYdjbgAeaDu8z+viBqXMJPUA7NQQj5b5xaW5Z631PVGZN49kt2KXhwG6CnMf2Nu+RM1c/Mv4iw4t0uiA2tlM3fHD+bSP/jJg+1qYcjTY37dQQpFQLcjfGAthGPKkmsttwNgQ/RpDzjo0BTpfNv3921tfJ++fNqmht21ETq3a+LYwOcc6okSfl1tBSBbxHkKtenANcHJh2SaX7ivljbeLI6BDnKHtLlZYq4A+CXOUIcPFgyq3urkudvLBjKBtCXEq1gJYq4I+GA7vlwh8/MeIvqqho6zwk5//4awJcTJy5+lGk/3x0Xeo0qmKIlxkf4miphkd15m0mvxDQThCm0q3Vj4y+kReUE591cO4oZmq310Q2yBHgzGd8iHMoW6oM/g3e+sp62FtAQGq310j37z80fkaWX7btqJEzVz+WE5++FfZWEIKNIBeVwLRxiSEq+wmCxkW7N4PYh9dsCXEp1YIJqnGA7058+pacufqx7Ko3cuSSL5pa90vfyOecOYq52u2l4BT2HLbSecyPYxXgbGZFiNNqqd7NM9cMCEDT4X1y4fYnsW+vbttRIx9ceFvO/IELDHiuo6tNLtz+JJQRTEcTR+TM1Y9i+TavxgXHso8HRJUVIc6hfEuVahwQjI326qkrH8ayKtfUul8u/PET6ehqC3sriKCGA7vlzB8+kq5LnYH8+Whq3S8Xbn8i75//WWw/UKyrizjLQezDa38X9gY81C8i/1xuQe7GnykhAwE6eKxZmlr3y3AqJ0MD2bC347td9XVy4rMOvs5Ay8YsuVxmTIYGsrI4522OaOs8JG3v/ZRWvsWsCXGDk73T3Y09EyJycKs1hUfTsji3HMvKgB9Uz+YUHk0HsxFEWu32Gjnx6VtypPOQ3B7ISi5j38ifbTtqpCNxRI4m2mJb6UDlNsLc7OMFyd0Yk/G7f6k40DW17peW483S1nmI34sxYE2Ic/SLyHflFgx/9zD0g6W2YMgr3NhZXyddlzrlnc86rAlzhLfN1Wp8bZjJz0dy7EaYGg7slvfP/0zeP/+zZ4PqZ/ILMpuff3amezY/L7vqf/Ls3/Gu+jrZ1fATaWrdT8WtDK+rnFFhW4i7KaUg99pWC3KZMUIcEKJXw9zEPfMuHe2qr5OjvzpCtWMLOuFM44xSrO2sr5Od9XXWPkgftMXZv6qWjASwDc9ZFeIGJ3uXuxt7bopI11Zr1leLksuMcWbFA7safqJcUxidCuUWFqJvI8ytrxZl/G5esqlc5J/I22hT8Rdr9UwL7jCbrb/frApxjpSUCXEiXHDwCmcL4YXa7TWengnyGmeMKtNwYLfMPt761ZbZ/Hzsx9AgOOV+LzrGg9iH16wLcYOTvSPdjT1PROT1rdZwwSE4UfmLGGZ49UzQ+L28FEanpDA6Fdgn6V31daXzRU54I7hVRnVmlq8NCIrm7zUjf0NaF+Ic/SLy23ILhgayvGHogabD+8reQtU4hwBsamd9nXR0tT2btTb7eEFm/jIvs/kFmcnPv3TYu1J7m/dI7Y4aaWrdL3ubd8ve5j2ykw93nmho3sPXBkSC5u81KnERkhKRpJS54DB+Ny/vny9yw9Jntp5DQPAaDuzedNL87OOFZ7/PCqNTW37/bTtqno3F+Xvn0Dj8s6uh/L9fRhAhKDpnbQcne6nERYX+BYc/y9HEkQB3Zh/Vp+3ZiB9Uh/leDHaMWIgOnRuqHGtBEGbzyvNwD4LYhx9senbrVf2qBcOpXBD7sJqqkvlfnHsBYkk1DFxEZOYvfMiD/zR+n00HsA1fWBviBid7x0WRrpfmlmX8Lu+pVkP1hXqJEAfE0rYdNcpLIVTqEQRbb6aKWBziHCnVgmzqYQDbsJfOmcKoz/4C4I+9zT8+w/iicmcYAS9o/h4jxEXR4GRvSkSelFtTeDRNyKiCziBfJrMD8aT6+sDlBvhN81LDiP878YfVIc6RUi3IcjauKqqWCZ+2gXjSOhfHh2j4qDA6rVoyEcA2fBOHENcvIk/LLchlxhg8WQVVy4R/t0A86VTq+ZAHP2n8/jK2lSoSgxDnzH65qVo3/B1n4yql+rTNUE8gnrbtqFHO49OolAAVmcnPy/qq8jjPSABb8Y31Ic6RVC3IZcYYTFshhnoC2Mo/qs7FUYmDTzR/b434vA1fxSLEDU72TotIutya9dUiN1UrpDPUk3MvQDypWqrrq0WCHHyhUeV94uQDY8UixDlSqgXDqRzVuAroHF7WmJgNwEKci0NYJu4p58COBLANX8UmxDlXiMsO/914igvu6Jx7YTI7EE+76us2ffP2RQxdh9c0f0+N+LwN38UmxDmSqgU8xVUZVUuVyexAfKmqcbOPF7jFDk9pVneVlx6jLlYhzqnGlR3+uzS3LLnMWDAbsohyMjuXG4DYoqWKoI2rW6kTzvQKo8UqxDmSqgW3B7IBbMMuOl+kudwAxFPL8WblGlqq8MpMfl7n3W7jq3AiMQxxOk9xUY1zj8sNAMo5eKx8kJu4l+diGTwxofeBgBBnsKRqAdU4d/SGetIuAeJKpxqncZsQUNKo6j4dnOw1+qWGDbEMcVTj/KG63MANVSC+VJU4EVqqqN7i3LLMPlZ2fayowonENMQ5kqoFVOPcaWrdV/bbZx8v0C4BYmrbjhrlqBFaqqjW+N2/6CwjxJmOapz3dF5uoKUKxFfbe4eUa2ipohoaY8KeDk72EuIskVQtoBqnjzECAMppOf6Gcg0tVVQqTrdSN8Q6xFGN817T4X1lv50QB8SXzusNtFRRqdwNrb+rCXGWSaoWUI3TpzOZnS/QQHzptFR5/hCV0Bjwa1UrVYQQp12NGyLIaaGlCqCcts6fKtdoVlSAZ8bv5mPXShUhxG1IqhYMp3JUkDQQ4gCUs21HjXLcyOzjBV54gSuaF2L6/d5H0AhxoleNW18tSjb1MJgNGY5zcQDK0Rn8SzUOutZWijpn15/YMuD3RYS455KqBVTj9HAuDkA5bZ2HpHZ7Tdk1XCiDLs0qXMrnbYSCEOfQrcZxNk5Np6XKLCgg3lTVuPVVreoKIMPfaXXJUj5vIxSEuJclVQuy6Zwsqg9Pxhrn4gCodCTalGtyN7ilivJm8vM6z2w9GJzsnQ5gO4EjxL3AqcY9UK2jGqemOrj8n4Q4INb2Nu+RnfV1ZdcUHk3zoRllZdUvNIhYWoUTIcRtJqlakMuMcXNKQfWO6tLcMv8OgZg7qlGN02yVIYbWVoo6L3w8dQo0ViLEvWJwsndENKpx1y/e8X8zBqOlCkBFa2Yc5+KwhVzmz7K+qrwklwpgK6EhxG0uqVpQeDRNCClDp1XCCAEg3rbtqJG2zvIvOHDBAVvReOxexMLZcC8ixG3CqcalVeuuUY0r6x8ZNQJAQRXiRGip4scKo1M6LzRYe6FhAyFua0nVgtnHC3xCLEN1uUGEUSNA3DW17ldW7WcfL9D5wEs0q3Apn7cROkLcFpz0rqzG3R7IUk3ags65OI1DqQAs985nHco1fGDGhsW5ZZ0CgNUXGjYQ4so7LSJPyy1YmlvmOa4t6LyRyKdrAAePNWu94MC4EYhot9etPgu3gRBXxuBk77Jo/EYYTjEAeCuqUSPrq1pXxAFYTOeCgwjDf6H9TqpIDFqpIoQ4Hf3Cc1wVazn+hnIN5+IAHP3VEeUa3q+G5liRtO0XGjYQ4hScalxStY4BwJvbVV8nDQd2l11DJQ7Arvo65fGL9dUiH/pijgsNLyPEaXAOR06o1jEAeHM6D11zNg6AzgsOt+l6xFYuM6Y7VmQkgO1EAiFO32nVgsKjaapKmzioCHEiVOMAlG60qyr3S3PL3FSNKc0LDSmftxEphDhNTrK/pVp3re8OZzZeofN6wzgtEgCidzaOCw7xUxidktnHC6plT+IwVuRFhDh3lNU4Ro5srkVx1mVpbpkzhQCkrfOQ8kMfzx7Gj+blwaTP24gcQpwLzm2Xr1TrGDnyY23v6YwPoEUCQO9sHBMB4qMwOiWFR9OqZU9F5Kb/u4kWQpx7SVEMAGbkyI/RUgWgq63zp8rhv1Tj4kP3oXtnmkSsEOJccjNyhC8wL9NpqfLvDMC2HTVa1TjNv9xhMN0ntiQmLzS8ihBXgcHJ3n7RGDlyjZEjL9FqqXLrDICIdCTUFxwm7uU5umI5za7WzThW4UQIcdVQXnKYfbwgw1xyeEarpcqoEQCi/xQXR1fstag/Tibp81YiixBXId2RI0MD9xk58gJVS5W3VAFsOPFZh3JNLjNGNc5SmgE9Nk9sbYYQV53TonHJ4XofbdUNOi1VntUBIFJ6iotqXDxRhdNDiKuCk/6Vhym55PCcTks1lxmjeglARKjGxRVVOD2EuOr1i8gT1SIuOTync+uMahwAEapxcUQVTh8hrkrOjRguObjQcvwN5RrOxQHYQDUuXqjC6SPEeWBwsvemiDxQreOSQ8mu+jrlI9eMDgCwgWpcfFCFc4cQ552EagGXHJ7TeeR6/O5fAtgJABNQjYsHqnDuEOI84vyG+kK1jksOJQcVo0ZEmMYO4DmqcfajCuceIc5bXHLQtG1HjTLILc0ty0x+PqAdAYg63WocH5TNRBXOPUKch9xccuDTomh9qs5SjQPgoBpnr8LoFFW4ChDiPKZ7yWE4lYv92Y2W481Su72m7Jrxu3kugwB4RqcaV3g0TTXOMFThKkOI80dCNF5ySJ+9EcxuIkz1qXp9tcjMOADPUI2zT2F0SgqPpnWWJv3diXkIcT7Qfcmh8Gg69vPQdJ7hyt34cwA7AWAK3Wpc3L++moIqXOUIcT4ZnOxNis4lh747sW4X7m3eI//tH3aWXVN4NB371jOA53SrcdcY6RR5ucwYVbgqEOL8lVAtWJpbjn3Zf21VHWKHv+O1CwDPvX/+beWZ2iX9kRUIyW29v/++ogq3OUKcjwYne0dEJK1al03nYnsId2ggK//fX9eU6/hCDOBF23bUaL3DfHsgG+tuR5TlMmOypO6yPBWqcFsixPnvtCguOYjEc3bc4tyyDH19X2vt+mqRIAfgJR2JI1rVuCzvVkfO2kpR9++9fmd8FzZBiPMZs+O25vZ2LhccALxItxo3nMpRjYuYbOqhrKuP0jwVjUuCcUaIC8DgZG9KmB33kuHUQ93DrM9wwQHAq0581iE76+vKrllfLcbuQ3KUra0UdZ9VTFKFK48QF5yEakFcZsetrRRlaECvjfoqLjgAeNU7GiNHsun4fEiOuut9d3SqcE8GJ3upwikQ4gLi3Kz5QrWu8Gja+rNf6XMZnT/Am7L93w0A99o6DymrcSLxPHscNTxy7y1CXIC0Z8ddtHd23PjdfFUvMHDBAcBmEpc6lWsm7uVjOwkgKjS7TRPOMSQoEOKCl1AtWF8tSvpcJoCtBGttpejJ8E0uOAB4VVPrfmk6vE+5jrNx4XHxvJbyMiBKCHEBc2bHfaVaN3Evb92TMUMDWZ2ZQCIi/0+5byw8mpaZ/Lw3mwJgjfcvvK1cE4cjK1GV0itOPHD+noQGQlw4kqIxOy59LmNNW7UwOiXZtNZtpFsicla1KKt3swlAjOxt3qP1HBcDgIM3nHqo+yE+4fNWrEKIC4FzZTqhWmfLtfi1laLuJ7CnUvr3clMUITeXGeOLMIAfOfFZBwOAI8bFRAIeuXeJEBeSwcnem1KqOpVlw5NcLtqoycHJ3mUn5N5ULc5lOBsH4GW76uu0BwAzciQYQwNZ3cG+nIVziRAXroRotFVTBrdVZ/Lzum3UB6/MBEqqvoPmsEgAMaPzHJctnY6oW5xb1v07gOe1KkCIC5HzGzapWrc0t2zsF5v0WVdt1GecknrZVy6W5patu/wBoHrbdtTIBxqXHHKZMeM7HVGnOVLkiTOCCy4R4kLmVJ+UT3KZ2FYdGsjK7OMFnaX9W5yDSKm+I+daAGymrfOQNBzYrVzHAGD/MFLEf4S4aEiIZW3Vmfy8DH2tdZB1YqtPYM6wx7LDkXlPFcBWdKpxs48XGDniExcjRZRnoLE5QlwEOFWopGqdSW1VzTaqiPqWbkr1A5jy7wRAsJpa98vBY83KdTa/khMWFxfaqMJVgRAXETa1VV20Ub8YnOwdV6xRPoDMuBEAW9GpxnHJwVtrK0Xdi2dpjb8DUAYhLloSOoui3Fb1oo36IufyR1q1jrNxADazq75OTnz6lnJdNp3jJRiPXO+7w0iRgBDiIsRpq36hWhfltqqHbdQXJVULGDcCYCvbd/2PWuuuc8mhaoXRKd0zhowU8QAhLmKc6tSEal0U26oet1Gf0Rk3sr5a5HAygE39n//7/6W1rvBomrFFVdK87ctIEY8Q4qIpobMoSm1Vr9uom1Cejbsd0eokgPAURqd0D9iLiMi1Pi45VGo49VD3g3zC563EBiEugpwqlVFtVZ/aqM84V9DLjhtZmluOXHUSQLjcfo3kXdXKuHgf9dbgZO+Iz9uJDUJcRJnUVvWrjbqJpM5eAECk1CHQHDb7kqGv7zN/0iXNywwiXGbwFCEu2hI6i8JsqxZGp/xuo77opiiGIjP8F8CGbBUXnjSfi4K4uszwxRav86BChLgIi3pbdW2lqDuRW8SDMxDOTSbl2TiqcQAW55aruuxUeDTNZSlNupcZROPrN9whxEWcm7Zq0LeqXEzkrraN+iKt4b9U44B4G/6u+nNtvOSg5uIyw2lGiniPEGeGd0XjbdV0gG3VwuiUZNNarQov2qjP6A7/9eILOAAzra14M3KIlxzKW5xb1r3MwPuoPiHEGUD3bdX11aKk9dubFQu6jbqJpGoBT3EB8ZVNPdQ5ZJ8Wka+UPxYvOWzp2kXtywwJn7cSW4Q4Q+i+rTpxL+97WzV9LhNGG/UZJ9TeKrdmfbXImAAgpjRfcElJ6QOhusuhP0IpNgqjUzJxT+vvGi4z+IgQZ5aEaLZV/ToTNn43r/sH19M26iaUZ+N4iguIn1xmTKc69GBwsnfEOZ6hHHkx+3hBhvlQ+IyLbgwvM/iMEGcQV21VH67Hr61ot2ufSukcn2+cYZE8xQXgJZovtzz7EDg42ZsSjS7H0ACz4zZkUw91uzEJn7cSe4Q4w+i2VQuPpj3/5Dh46qru+YdkQOVznuIC8EwuM6YTLp5scsg+ofpO66tF3VEaVnPxxCIvMwSAEGcmrduqQwP3PTuQO5x6qDv5/IETNH2n+xQX1TggHjQ/tCVf/S+cD53KmZxBnDmOuut6QfapUIULBCHOQM45joRqXamtWv2B3Jn8vO418jD+4CZVC6jGAfbTfOj+idM+3Uy/KD4Uiohc64vv7DgXH+aTzIQLBiHOUE4VquwNTZHSgdxq5xylz2a0r5EHfQvJ+YKsrMaF/b4sAH9pfp3bskug++E4rBdywubigfuJoLoxIMSZLiEanxyHvr5fcYhx8bj9rRCHOSZVC+L4RReIi8LolE6F6KmUxopsyTnDpfxwHMfZcelz+h/mfd4KXkCIM5juJ0cRkVQFrzm4eNw+7PMPN0VxRrDwaJpqHGAp3SqcZosvIcyOaQm3bgAAGI1JREFUe4mL0VJf+TEbFFsjxBnO+eSonDq+NLcsl09+ox3kZvLzcuXU97rbeDfM8w/Oz60s31ONA+zjogqn1eJzvp4kVeu8OKpigrWVolzr037gPunvbvAqQpwFBid7T4vIhGrd7OMFufjz3ykrUsOph9L389/rls6/isg18n6hGgfEjsdVOBHRH+U0nMpZPztuaCCrOxOOB+5DQIizR0Jn0dLcslz+5bdy+eQ3pZtGo1PP/hkayMq/tn8p1/v+pPtzTkhEPnlRjQPiZ3FuWfe2ZCUH7ZUvOfg1WD0qCqNTkk1rvXwT5pnoWPubH374Iew9wCPdjT2nReS3Af6Uh6J0/qG7sadORKZF5LVy68784SNpat0fyJ4A+Cd9LqMzBzI9ONmbqOTH727sSYrIv6nWvX/+Z3I0caSSnyLSLr7zO52LbU9FZB9VuHBQibOIbgvAI/8SpQAn8qwal1Kt401VwHyL+oO8k5X+HM67n+oJAAP3rZsd52IyATPhQkSIs8+7onE+rkrpCM8BUu5r4l7e+nMsgO00j0akPZhdmVAtWF/VflfaCC6e1grshR5sjhBnGecTUbv4F+Qqbk0EwfmCnVat42wcYK4gqnAbdCcA2PQkl4vxKQkftwENhDgLvRDkvG6tfhHlAPeCpGpBLjNGNQ4wVIBVuA1J0ZkdV8E8zqhx0Ub9IugXevBjhDhLDU72Lg9O9raLyL+IxhcfhSci8pZzPiTyqMYB9gqyCrfB1XvVBrdVF+eWdc8MT5jy94HtCHGWc84r7JNSqHEb5p6IyK8GJ3v3RWQWnBtJ1QKqcYB5QqjCiYj+e9UT9/LGzqNMn73B01qGIcTFgFOVS0gpzP1KSoFuqxtXE1I6//FPTnhLBbBFz1GNA+wTRhXuFQnR+DBcyTOHYRtOPdSducfTWhHCnDhYq7uxZ5+IKD8S9418Lrvq6/zfEICq+D0XTkd3Y09CRL5TrevoapMPLrzt1zY8tTi3LBff+Z1OFe6JiLQwUiQ6qMTBWlTjAHtEoAonIiJOd0J5aSybzhnTVnXTRiXARQshDrZLqhZwNg6IvrDOwm0hIZa0VV22UUf83Q3cIsTBarrVOJvfPwRMF5Uq3Abn64ry51qaW450pX9xblmGBrSG+j6RiLyTjZcR4hAHSdWCwqNpY1ofQNxErAonIvrPHEa5rUob1XyEOFiPs3GAuaJWhXtFQgxtq9JGtQMhDnGRVC2gGgdEj+ZRh0CrcBtMbavSRrUHIQ6xQDUOME9hdEq3WpT0dydbM7GtShvVHoQ4xElStYBqHBAdUTwLt4WEaLRVr5z6PvS2Km1UuxDiEBtU4wBzmFCF26DbVg37bVXaqPYhxCFukqoFVOOA8BlUhRMR/bbqxL28jN/NB7CjH7vSfZU2qmUIcYgV5wv+F6p11y7e8X8zADZlUhXuFQnRaKumQ7itOjSQldnHCzpLaaMahBCHOOoXxRfa2ccLumMNAHhM80PUV1Gpwm2Ialt1Jj8vQ1/TRrURIQ6x47QJ+lXrbnM2DghcLjOmUzF6KhENG27aqkF9UEyf1Q6MtFENQ4hDXCmrcUv6Q0YBeETzw1N/xMNGQjTaqtcu3vH93eZrF+/QRrUYIQ6xRDUOiJ5cZkyW1KHmqWj82Q2T01Y9rVq3vlr09d3mwuiUZNM5naW0UQ1FiEOcaVXjGDkCBMOSKpyIiAxO9qZE5JZqXeHRtAynHnr+86+tFCWlf+6ONqqhCHGILeeLVlK1bjiVC31AJ2C7oYGsFVW4VyREo616ve9PMpOf9/Qnvt53R+ffp4jIF7RRzUWIQ6w5h5CflFuzvlqUrA+flAGUrK0UZTil1fZLmlQxcvaa0Fnr4vKB0vhd7UsTE4OTvUnPfmIEjhAHUI0DQpVNPdQZQvvE+dBllMHJ3pui8VLM7OMFT45urK24Gl+SqPonRKgIcYg95+yKshp3vY8BwIDXFueWtatwPm/FT6dF8TVGRGTo6/tVvxYzeEr7VYZ/GZzsHa/qJ0PoCHFAifImWS4z5vs4ACBuhgayulW4VADb8YWbtmqqitccXDxu/8DEqiZ+jBAHyLOWh3JAJzdVAe8s6s9iVH7Iijrn8sBXqnVLc8sVveYwk5/Xfdz+qdBGtQYhDnguqVqQy4xV3e4AUKL5vNYD50OW8QYne0+LyIRq3cS9vKsgt7ZSlCunvtdto56O2nNlqBwhDnA4n5SpxgEBKIxOycS9vM7SpM9bCVpCZ1EuMyZpjdZqYXRKzrd/qTtO5JbJbWn8GCEOeJmybVN4NE01DqiS5oehB7bNMHMuE/yLztpcZkwu/vx3Mpx6+KPzuIXRKUmfy8jlX36rW4GjjWqhv/nhhx/C3gMQKd2NPSkR6Sq3Zmd9nfz7yOfBbAiwzPjdvAz++nudpYdsvUHZ3dgzIiJvuv1+O+vrdKtur3rLtkAMKnHAZpKqBUv6B7IBvOKa3rietK0BzpEQjdccXlVhgONxe0sR4oBXOId+lbfIbg9kGQAMuKT5yL2IfWfhXuJ8nXk3gJ/qgXOhAhYixAGbS4riU/LS3DLPcQEurK0UdW+kfhGHG5ROdexXPv4UExJMUERICHHAJpzhnMphmDzHBejTfF7LtEfuq+LcFv0nqaC1qnBLRNpNemsW7hHigK31C89xAZ5w8bxWf9yChzMHr0U0Rhxp+mJwsvfduP17jCNCHLAF5wtgUrWO57gANRfPayUD2E7kDE72Tg9O9rZLqb2qfGd1C2kR2R/Xf4dxxIgRQKG7sWdcRA6WW9N0eJ+cufpxQDsCzDKTn5e+n/9eZ+mvGEZb0t3Yk5DSebZ2EXmtzNIJERmRUgVz2u99IVoIcYBCd2NPu4goHyU884ePpKl1v/8bAgxz+eQ3Og+zTwxO9rYEsB3jdDf2tIhInZRarnUiMi4iyyIyTss03ghxgAadwZwNB3bLhdufBLMhwBCF0Sm5/MtvdZYyjBZwiTNxgB7lnKXZxwsMAAZekdJ7yN2657WAIBDiAA3O5Pi0ah0DgIHnXAz2Tfi8FcBKhDhAX1IYAAxocTHYN82BfKAyhDhAk/MXjdYAYEaOIO5cDPblSSigQoQ4wB2tAcBDA9mAtgNEz+Lcsgx9rbzQLRLDwb6AlwhxgAtuBgDP5Of93xAQQZpt1NgO9gW8QogDXHKGkU6o1l3X+4sMsEphdEom7uV1liZ93gpgPUIcUBnlOZ7Co2kZv6v1lxlgDc2jBA94mQGoHiEOqIAz0+qWat21PqpxiI9cZkznZQYRqnCAJwhxQOWU1biluWUuOSAW1laKclvv93qawb6ANwhxQIWckSNfqdYNp3IMAIb1sqmHOoN9nwpVOMAzhDigOklRDABeXy3KddqqsJjLkSLTPm8HiA1CHFAFNyNHCqNT/m8ICIHmSJGnojEsG4A+QhxQpcHJXuUAYBHtW3uAUVyMFDnNYF/AW4Q4wBsJ1YLCo2nJZcYC2AoQHM0qHCNFAB8Q4gAP6I4cuT2Q5ZIDrJHLjMns4wWdpUmftwLEEiEO8I7WyJFs6mEQewF8tbZS1K3CMVIE8AkhDvCIc+vuC9W6oa/vy6J6FAMQaUMDWVlfVVaVGSkC+IgQB3irXxQjR0S0zxEBkbQ4tyzZdE5nKSNFAB8R4gAPObfvlG3ViXt5Ro7AWOmzN3SWPRFGigC+IsQBHnNu4U2o1qXOZfzfDOCx8bt53fdRGSkC+IwQB/hD65LDMJccYJC1laJc03t95MHgZO9Nv/cDxB0hDvCBcxsvrVo3NHCfkSMwhub7qCIaH2IAVI8QB/gnKbyrCksszi3LcErrMsNXg5O9437vBwAhDvCNcytPebCbd1VhgmsX7zBSBIgYQhzgo8HJ3qRovKvKyBFEmYv3UZNcZgCCQ4gD/JdQLZh9vMAlB0SW5k3qicHJXkaKAAEixAE+cy45PFCt45IDomhoIMtlBiCiCHFAMBKqBeurRRkayAawFUCPi8sMvI8KhIAQBwRA913VbDonM/l5/zcEaHBxmYEqHBACQhwQnH7RuORwnUsOiAAXlxn6ucwAhIMQBwRE913VwqNpyWXGAtgRsDXNywxPnBvYAEJAiAMC5DxFpLzkcO3iHS45IDQuLjMkfN4KgDIIcUDwEqoFXHJAWFxcZrjFZQYgXIQ4IGBuLjnwkgOCxmUGwByEOCAcWpcceMkBQXJ5mWHa5+0AUCDEASHQveTASw4IEpcZALMQ4oCQ6F5y4CUHBIHLDIB5CHFAuBKqBeurRbneR1sV/uEyA2AmQhwQIt1LDrnMGJcc4Jv02RtcZgAMRIgDwsclB4Rm/G5eCo+mdZYmucwARAshDgiZm0sOzI6Dl9ZWinJNr1U/MTjZ2+/3fgC4Q4gDIsC55HBLtW44lZNFvcPngJKLywy0UYEIIsQB0XFaSueOtrS+WqStCk/M5Oclm9a6zJDmMgMQTYQ4ICKc80bKltXEvbyM39UayAps6brehwEuMwARRogDIsQZoqq+5NB3h9lxqNhw6qGbywz074GIIsQB0ZNQLViaW5YsLzmgAmsrRRkauK+z9AGXGYBoI8QBEeOcP0qr1g19fV9m8vP+bwhWud6n9cC9CG1UIPIIcUA0KS85iGifawJEpPTAfS4zprP0q8HJ3nG/9wOgOoQ4IIKcc0hJ1brCo2kZpq0KTboP3IvG7z0A4SPEARHlnEd6oFo3NHCfSw5QcjMTjssMgBkIcUC0Kc8lra8WJa1XYUFMLc4ty9DX2pcZbvq9HwDeIMQBEeacS/pKtW7iXl4Ko1MB7AgmSp+9obPsqWjcjAYQHYQ4IPqSojE7LnUuQ1sVP5LLjOnOhOvngXvALIQ4IOKc80nKtiqz4/CqtRXtZ9omnEHTAAxCiAMM4JxTuqVax+w4vIiZcIDdCHGAOZgdB20uZ8KN+LwdAD4gxAGGcM4rJVXrmB2HtZWi7ky4p8JMOMBYhDjAIM7suAnVuqGB+7KoNxMMFsqmHurOhEswEw4wFyEOME9CtWB9VftAOywzk59nJhwQE4Q4wDBuZseN380HsCNEieaZSGbCARYgxAFmSorG7LhrfXeYHRcjw6mHzIQDYoQQBxjIOceUUK1bmluWoYGs/xtC6BbnlmVoQKuNykw4wBKEOMBQzlgI5ey4bDrHk1wxcO2i9ky4hM9bARAQQhxgtoRozI7THDcBQ43fzcvEPa3zj185ZyoBWIAQBxjMaasmVetoq9prbaUoab2Q/kSYCQdYhRAHGM6ZHfdAtY4nuew0NJDVbqMyEw6wCyEOsENCZxFPctmlMDol2XROZ+ktntYC7EOIAyzgjIv4QrWOJ7ns4fJprYS/uwEQBkIcYAlnbARPcsWEi6e1TtNGBexEiAPsklAtWF8tSvrsjQC2Ar+4fFor5fN2AISEEAdYRPdJrsKjaZ7kMlj6LG1UAIQ4wEZJ0XiSK30uw5NcBhoayMrs4wWdpUme1gLsRogDLKP7JNf6qvZ8MUTE4tyybht1whk9A8BihDjAQrpPck3cy9NWNYiLs4wJH7cBICIIcYC9EqLxJBdtVTMMpx5K4dG0ztIveFoLiAdCHGApN21VnuSKtsW5ZRka0GqjPnFGzQCIAUIcYLHByd6botFWzaZzUhidCmBHqET67A3tp7V83gqACCHEAfY7LRpt1RRt1Uhy0Ub9iqe1gHghxAGWc8ZMJFXrluaWaatGzNpKUbuNKhq/xgDsQogDYsAZN/FAtY62arSkz2W026g8rQXEDyEOiI+EaLZVEb7xu3mZuKc1/iVNGxWIJ0IcEBO0Vc2xtqI9iPmplM48AoghQhwQI7pt1aGv78tMfj6AHWEztFEB6CDEAfGjVbnRfGQdHnPRRr3ljJABEFOEOCBmnGn+X6jWzT5eoK0aMJdt1IS/uwEQdYQ4IIacqf4TqnW0VYNFGxWAG4Q4IL4SOotoqwaDNioAtwhxQEzRVo0O2qgAKkGIA2KMtmo0uGijJmmjAthAiAOQ0FlEW9UfLtqoD5wRMQAgIoQ4IPZoq4aHNiqAahDiANBWDYnLNuq0z9sBYBhCHIANCZ1FtFW9QRsVQLUIcQBEhLZqkGijAvACIQ7AM7RVg0EbFYAXCHEAXpXQWURbtTK0UQF4hRAH4CW0Vf1DGxWAlwhxAH6Etqo/aKMC8BIhDsBWEjqLaKvqoY0KwGuEOACbctNWvXbxTgA7MhdtVAB+IMQB2JJuWzWbzklhdMr/DRmKNioAPxDiAKgkdBalzmVkbUUrqMSKizbqLdqoANwgxAEoS7etujS3zG3VVyzOLdNGBeAbQhwAJdqqlUmfvaHbRk0MTvYu+70fAHYhxAHQldBZRFu1ZDj1UAqPpnWW3hqc7L3p83YAWIgQB0CLm7bq9b5431ZdnFuWoYH7OktpowKoGCEOgDbdtmouMybjd7UO81uJNiqAIBDiALj1rpQqSGWlY9pWpY0KICiEOACuOHPMkqp166vaA26tMZOfl+t9f9JZShsVQNUIcQBcc+aZPVCtm7iXj1Vb1cUTZO/SRgVQLUIcgEolRLOtujhnf14ZGsjK7OMFnaVfDU72jvi8HQAxQIgDUBFXbdWzN3zfT5hm8vMy9LXWbdQnovHvDAB0EOIAVMxpq95SrSs8mpbh1MMAdhS8tZWiXDn1ve5ybqMC8AwhDkC1EqLRVh0auG9lW3VoICtLev+7aKMC8BQhDkBVnMpSQrVufbUoV7qv+r+hABVGpySbzuksnRic7D3t934AxAshDkDVnHlnyrbq7OMFGRrIBrAj/7lto/q4FQAxRYgD4JWElA7ulzX09X2Zyc/7vxufpc9ldF9l+MJ5sgwAPEWIA+AJ3baqiMiVU98b/ZrD+N28TNzTmn834TxVBgCeI8QB8IxzcP8r1bqluWVj26qLc8u6L1E8ldITZQDgC0IcAK8lRaOtmk3npDA65f9uPObicfukM0sPAHxBiAPgKaetqlWBMq2t6uJx+wfODD0A8A0hDoDnnIP8X6jWra8WdVuToXP5uD1tVAC+I8QB8IVzoH9CtW7iXl5ymTH/N1QlF4/b8yoDgEAQ4gD46V3ReM3h2sU7kX7N4drFO7qP299yZuYBgO8IcQB84xzsT6rWra8WJX32hu/7qYSLVxmeCEN9AQSIEAfAV84B/weqdYVH05EbO7K2UpSU/pk92qgAAkWIAxAErbZq1F5zSJ/L8Lg9gMgixAHwnYmvOeQyY25eZeBxewCBI8QBCIRz4D+tWrc0tyzX++4EsKOtzeTn5dpF7T0kfNwKAGyJEAcgSKdF4zWHXGZMhlMPA9jOj62tFCV9Vvtx+3/hcXsAYfmbH374Iew9AIiR7saeFhHRGgzXdalT2joP+byj59ZWinL55De640QeDE72tvu8JQDYEpU4AIHSfc1BpHSxIKhBwC4DHK8yAAgdlTgAoehu7BkXkYM6a098+pac+KzDt73M5OclfTajG+BERP6Job4AwkYlDkBYtMaOiJRGj1w++Y0vrzrkMmNy+eS3bgJcmgAHIAqoxAEITXdjz7si8h+662u318jRRJt0JI7Ith01Vf3cM/l5uX7xjhQeTbv5bhODk70tVf3EAOARQhyAUHU39iRE5Ds332cjzLW991PZVV/n6ucbv5t3MwPuRRMi0s6rDACighAHIHSVBLkNDQd2S8vxZmlq3S+7Gn7yo1BXGJ2SxbllKYxOyfjdvO7okFc9FZEW5y1YAIgEQhyASKgmyPlsQkrvojIPDkCkEOIAREYEgxwtVACRRYgDECnOMOCbIvJ6yFv5ijdRAUQZI0YARIrTtmwRkVshbeGp/P/t3bFtAkEQQNEpwU1Qh+nEDmkCiRbcAe6EElwCdOASHNxFjhyAdR+9l9/GX3Or2WUPnIADNs0kDtisw+64n5nz/N9U7mNmTn6fAgUiDti89a7caR4Xc5+zxNv1QecD3J2IAzLWydz7zLzd4bjbLFO+s3gDikQckLS+9rCf5f7c6x8+uc3M18xcZuZiZQhQJ+KAp3DYHV9mCbrfvgUb8IxEHABAkBUjAABBIg4AIEjEAQAEiTgAgCARBwAQJOIAAIJEHABAkIgDAAgScQAAQSIOACBIxAEABIk4AIAgEQcAECTiAACCRBwAQJCIAwAIEnEAAEEiDgAgSMQBAASJOACAIBEHABAk4gAAgkQcAECQiAMACBJxAABBIg4AIEjEAQAEiTgAgCARBwAQJOIAAIJEHABAkIgDAAgScQAAQSIOACBIxAEABIk4AIAgEQcAECTiAACCRBwAQJCIAwAIEnEAAEEiDgAgSMQBAASJOACAIBEHABAk4gAAgkQcAECQiAMACBJxAABBIg4AIEjEAQAEiTgAgCARBwAQJOIAAIJEHABAkIgDAAgScQAAQSIOACBIxAEABIk4AIAgEQcAECTiAACCfgBaxatu4t+UvAAAAABJRU5ErkJggg=="
                      />
                    </defs>
                  </svg>

                  <p
                    v-if="selectedCategoriesArrayTitles.length > 1"
                    class="stepper-content-label--mini"
                  >
                    {{ selectedCategoriesArrayTitles.length }}x Categories
                    Selected
                  </p>

                  <p
                    v-else-if="selectedCategoriesArrayTitles.length === 1"
                    class="stepper-content-label--mini"
                  >
                    {{ selectedCategoriesArrayTitles.length }}x Category
                    Selected
                  </p>

                  <p
                    v-if="selectedCategoriesArrayTitles.length === 0"
                    class="stepper-content-label--mini"
                  >
                    {{ selectedCategoriesArrayTitles.length }}x Categories
                    Selected
                  </p>
                </div>
              </div>
            </v-card>
          </div>
          <div class="buttons-wrapper">
            <v-btn
              class="button-cancel"
              color="lightgrey"
              @click="stepperCount = 3"
            >
              Back
            </v-btn>

            <div class="buttons-continue">
              <v-btn color="accent" @click="updateMap()">
                {{ confirmButtonText ? "Continue" : "Update" }}
              </v-btn>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </form>
</template>

<script>
import axios from "axios";
import ImageUploader from "@/components/Library/ImageUploader";
import MapPicker from "@/components/Library/MapPicker";
import Editor from "@tinymce/tinymce-vue";
import PageSelector from "@/components/Library/PageSelector";

export default {
  name: "EditMapDirectory",

  components: {
    ImageUploader,
    MapPicker,
    "tinymce-editor": Editor,
    PageSelector,
  },

  created() {
    if (this.$route.path != "/map-directory/create") {
      this.getMapData();
      this.getCategoriesArray();
      this.heading = "Editing Map";
      this.isExistingMap = true;
      this.confirmButtonText = false;
    } else {
      this.heading = "Creating New Map";
      this.getCategoriesArray();
      this.isExistingMap = false;
      this.confirmButtonText = true;
    }
  },

  computed: {
    unselectedCategories() {
      if (!this.categoriesArray) {
        return [];
      }

      return this.categoriesArray.filter(
        (category) => !this.selectedCategoriesID.includes(category.id)
      );
    },
  },

  watch: {
    mapToggleAuto(newValue) {
      if (newValue) {
        this.mapToggleFixed = false;
        (this.updatedData.areaLat = null),
          (this.updatedData.areaLong = null),
          (this.showStepperAddress = false),
          (this.updatedData.areaType = "auto");
      }
    },
    mapToggleFixed(newValue) {
      if (newValue) {
        this.mapToggleAuto = false;
        (this.showStepperAddress = true), (this.updatedData.areaType = "fixed");
      }
    },
  },

  data: () => ({
    api: process.env.VUE_APP_MAPDIRECTORYAPI,
    isExistingMap: null,
    confirmButtonText: null,
    mapId: null,
    stepperCount: 0,
    locationPinColor: "red",
    heading: null,
    stepperHeight: "400px",
    showStepperAddress: false,
    mapToggleAuto: false,
    mapToggleFixed: false,
    updatedData: {
      mapTitle: null,
      areaType: null,
      areaLat: null,
      areaLong: null,
      categoriesArray: [],
    },
    categoriesArray: [],
    selectedCategory: null,
    selectedCategoriesArray: [],
    selectedCategoriesArrayTitles: [],
    selectedCategoriesID: [],
  }),

  methods: {
    deleteSelectedCategoryTitles(id) {
      const deleteIndex = this.selectedCategoriesArrayTitles.findIndex(
        (obj) => obj.id === id
      );
      this.selectedCategoriesArrayTitles.splice(deleteIndex, 1);

      const deleteIndexID = this.selectedCategoriesID.findIndex(
        (obj) => obj === id
      );
      this.selectedCategoriesID.splice(deleteIndexID, 1);
    },

    updateSelectedCategoriesArray(payload) {
      this.selectedCategoriesArrayTitles.push({
        id: payload.id,
        title: payload.attributes.title,
      });
      this.selectedCategoriesID.push(payload.id);
    },

    cancelMap() {
      this.$router.push({ path: "/map-directory" });
    },

    getMapData() {
      this.$store.commit("startLoading");
      this.mapId = this.$route.params.id.substring(0);
      this.$getCurrentUserJwToken().subscribe((jwt) => {
        axios({
          method: "GET",
          url: `${this.api}/maps/${this.mapId}`,
          headers: { Authorization: jwt },
        })
          .then((response) => {
            if (response.data.data && response.data.data.attributes) {
              (this.updatedData.mapTitle = response.data.data.attributes.title),
                (this.updatedData.areaType =
                  response.data.data.attributes.areaType),
                (this.updatedData.areaLat =
                  response.data.data.attributes.coords.lat),
                (this.updatedData.areaLong =
                  response.data.data.attributes.coords.lng),
                (this.selectedCategoriesID =
                  response.data.data.attributes.categories);

              if (
                this.categoriesArray &&
                response.data.data.attributes.categories
              ) {
                this.selectedCategoriesArrayTitles =
                  response.data.data.attributes.categories.map((c) => {
                    const category = this.categoriesArray.find(
                      (fc) => fc.id == c
                    );
                    return category
                      ? { id: category.id, title: category.attributes.title }
                      : "";
                  });
              }
            }

            if (response.data.data.attributes.areaType == "auto") {
              this.mapToggleAuto = true;
            } else {
              this.mapToggleFixed = true;
            }

            this.$store.commit("completeLoading");
          })
          .catch((e) => {
            console.error("Problem receiving map data", e);
            this.$store.commit("completeLoading");
          });
      });
    },

    updateMap() {
      this.$store.commit("startLoading");
      this.mapId = this.$route.params.id.substring(0);

      if (this.isExistingMap) {
        this.$getCurrentUserJwToken().subscribe((jwt) => {
          axios({
            method: "PATCH",
            url: `${this.api}/maps/${this.mapId}`,
            headers: { Authorization: jwt },
            data: {
              data: {
                attributes: {
                  title: this.updatedData.mapTitle,
                  areaType: this.updatedData.areaType,
                  coords: {
                    lat: Number(this.updatedData.areaLat),
                    lng: Number(this.updatedData.areaLong),
                  },
                  categories: this.selectedCategoriesID,
                },
                type: "string",
                id: this.mapId,
              },
            },
          })
            .then((response) => {
              this.$router.push({ path: "/map-directory" });
              window.alert("Successfully Saved");
              this.$store.commit("completeLoading");
            })
            .catch((e) => {
              console.error("ERROR POST map data", e);
              window.alert("Please define a map name and area");
              this.$store.commit("completeLoading");
            });
        });
      } else {
        this.$getCurrentUserJwToken().subscribe((jwt) => {
          axios({
            method: "POST",
            url: `${this.api}/maps`,
            headers: { Authorization: jwt },
            data: {
              data: {
                attributes: {
                  mapID: this.$uuid.v1(),
                  title: this.updatedData.mapTitle,
                  areaType: this.updatedData.areaType,
                  coords: {
                    lat: Number(this.updatedData.areaLat),
                    lng: Number(this.updatedData.areaLong),
                  },
                  categories: this.selectedCategoriesID,
                },
                type: "string",
              },
            },
          })
            .then((response) => {
              this.$router.push({ path: "/map-directory" });
              this.$store.commit("completeLoading");
            })
            .catch((e) => {
              console.error("ERROR POST map data", e);
              window.alert("Please define a map name and area");
              this.$store.commit("completeLoading");
            });
        });
      }
    },

    getCategoriesArray() {
      this.$store.commit("startLoading");

      this.$getCurrentUserJwToken().subscribe((jwt) => {
        axios({
          method: "GET",
          url: `${this.api}/categories`,
          headers: { Authorization: jwt },
        })
          .then((response) => {
            this.categoriesArray = response.data.data;

            this.$store.commit("completeLoading");
          })
          .catch((e) => {
            console.error("Problem receiving categories array", e);
            this.$store.commit("completeLoading");
          });
      });
    },
  },
};
</script>

<style scoped lang='scss'>
@import "../../styles/settings";

.stepper {
  &-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 90px;
  }

  &-content-container {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
  }

  &-content {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
    width: 130px;
    height: 130px;
    margin: 44px;
    border-radius: 4px;
    background-color: #f9f9f9;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  }

  &-content-label {
    font-size: 14px;
    font-weight: 200;
    text-transform: uppercase;
    color: #516173;

    &--mini {
      color: #24002f;
      font-size: 12px;
      font-weight: 500;
      text-transform: capitalize;
      text-align: center;
    }
  }

  &-icon {
    width: 45px;
    height: 45px;
  }
}
.half {
  width: 100%;
}

.section-divider {
  margin-bottom: 24px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dfe3e9;
}

.input {
  &__textfield {
    &--basic {
      margin-top: 0;
    }
  }
}

.faded {
  opacity: 0.5;
}

.stepper-header {
  box-shadow: none;
}

.buttons-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.button-cancel {
  color: white;
}

.button-skip {
  color: purple;
  background-color: none;
  box-shadow: none;
}

.label-summary {
  width: 100%;
  text-align: center;
}

.checkbox {
  &-wrapper {
    display: flex;
    justify-content: center;
  }

  &-auto {
    // background-color: red;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 5px;
    width: 200px;
  }

  &-label {
    margin: 0;

    &--mini {
      color: #a8aab7;
    }
  }

  &-label-wrapper {
    width: 150px;
    height: 84px;
  }

  &-image {
    width: 70px;
    height: 70px;

    &--mini {
      width: 52px;
      height: 52px;
    }
  }
}

.selected {
  &-categories-container {
    display: flex;
    width: 200px;
    height: auto;
    flex-wrap: wrap;
  }

  &-category {
    display: flex;
    align-items: center;
    height: 30px;
    width: 170px;
    background-color: #aecbe1;
    color: white;
    font-size: 12px;
    font-weight: 400;
    margin: 10px;
    border-radius: 4px;
    padding: 0 0 0 10px;
  }

  &-category-wrapper {
    display: flex;
    width: 100%;
    position: relative;
  }

  &-category--icon {
    position: relative;
    right: 40px;
    color: white;
  }
}

.fixed-address-lattitude {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.fixed-address-longtitude {
  display: flex;
}
.fixed-address__label {
  margin: 13px 0 0 0;
  width: 80px;
}
</style>
